export const feedMediaLibraryLocalStorageKey = 'scheduler_feed_media_library_active';

const defaultValue = true;

export const getFeedMediaLibraryLocalStorage = () => {
    const valueLocalStorage = localStorage.getItem(feedMediaLibraryLocalStorageKey);
    return valueLocalStorage ? Boolean(Number(valueLocalStorage)) : defaultValue;
};

export const setFeedMediaLibraryLocalStorage = (mediaLibrary: boolean) => {
    if (mediaLibrary === defaultValue) {
        localStorage.removeItem(feedMediaLibraryLocalStorageKey);
        return;
    }
    localStorage.setItem(feedMediaLibraryLocalStorageKey, JSON.stringify(Number(mediaLibrary)));
};
